module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid21_960x869.8f6a571.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid21_960x869.jpg
// module id = Um/N
// module chunks = 0